import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" width="32" height="33" viewBox="0 0 32 33" {...props}><path d="M16.023 4c.562 0 1.023.527 1.023 1.164v22.904c0 .652-.461 1.178-1.023 1.178-.566 0-1.023-.526-1.023-1.178V5.176C15 4.526 15.457 4 16.023 4z" /></svg>);